import React, { useEffect, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import { ServerPath } from '../../Constant';

const EditPrefilled = ({ show, handleClose, currentAmount, onUpdateSuccess }) => {
    const [amount, setAmount] = useState(currentAmount);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        setAmount(currentAmount);
    }, [currentAmount]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
    
        try {
            const response = await axios.put(`${ServerPath}/prefilled-details/update`, {
                prefilled_id: 1,
                prefilled_amount: amount,
                modified_by: 'admin'
            });
    
            if (response.data.success === 1) {
                if (onUpdateSuccess) {
                    onUpdateSuccess();
                }
                // First close modal
                handleClose();
                
                // Show toast after modal closes
                setTimeout(() => {
                    const toastDiv = document.createElement('div');
                    toastDiv.style.cssText = `
                        position: absolute;
                        top: 2px;
                        right: 20px;
                        background: white;
                        padding: 18px 20px;
                        border-radius: 4px;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                        z-index: 1050;
                        border-left: 4px solid #4CAF50;
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.87);
                        min-width: 250px;
                        min-height: 30px;
                    `;
                    toastDiv.textContent = 'Changes updated successfully.';
                    
                    const containerElement = document.querySelector('.container-fluid');
                    if (containerElement) {
                        containerElement.style.position = 'relative';
                        containerElement.appendChild(toastDiv);
                    }
                    
                    // Reload after toast shows for 2 seconds
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }, 300);
            } else {
                setError(response.data.message || 'Update failed');
            }
        } catch (err) {
            console.error('Error updating prefilled amount:', err);
            setError(err.response?.data?.message || 'Failed to update amount');
        } finally {
            setLoading(false);
        }
    };

    // Handle amount input validation
    const handleAmountChange = (e) => {
        const value = e.target.value;
        // Allow only numbers and decimal point
        if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
            setAmount(value);
        }
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="sm"
            centered
        >
            <Modal.Header closeButton style={{ border: 'none', paddingBottom: '0' }}>
                <Modal.Title style={{
                    fontSize: '1rem',
                    fontWeight: '500',
                    color: '#111827'
                }}>
                    Prefilled Amount
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ paddingTop: '0.5rem' }}>
                <Form onSubmit={handleSubmit}>
                    <Form.Group>
                        <Form.Label style={{
                            fontSize: '0.875rem',
                            color: '#4B5563',
                            marginBottom: '0.5rem'
                        }}>
                            Amount <span style={{ color: '#DC2626' }}>*</span>
                        </Form.Label>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid #D1D5DB',
                            borderRadius: '0.375rem',
                            padding: '0.5rem 0.75rem',
                            backgroundColor: '#F9FAFB'
                        }}>
                            <span style={{ color: '#4B5563', marginRight: '0.25rem' }}>₹</span>
                            <input
                                type="text"
                                value={amount}
                                onChange={handleAmountChange}
                                style={{
                                    border: 'none',
                                    background: 'transparent',
                                    width: '100%',
                                    outline: 'none',
                                    padding: '0'
                                }}
                                disabled={loading}
                            />
                        </div>
                        {error && (
                            <div style={{ color: '#DC2626', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                                {error}
                            </div>
                        )}
                    </Form.Group>

                    <div className="d-flex justify-content-end" style={{ marginTop: '2rem' }}>
                        <Button
                            type="submit"
                            style={{
                                backgroundColor: '#6366F1',
                                border: 'none',
                                padding: '0.5rem 2rem',
                                borderRadius: '0.375rem',
                                fontSize: '0.875rem'
                            }}
                            disabled={loading}
                        >
                            {loading ? 'Updating...' : 'Update'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditPrefilled;